// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { FIREBASE_CONFIG } from "./constants/environment";
// https://firebase.google.com/docs/web/setup#available-libraries

const app = initializeApp(FIREBASE_CONFIG);

export const auth = getAuth(app);
